<template>
    <div>

        <div id="box" style="display: none;">
        </div>
        <!-- <div class="box"></div> -->
        <!-- 定部 -->
        <div class="header">
            <div class="header-l" @click="navto(1)">
                <img src="../../../assets/images/手机端/首页手机端/logo拷贝.png" alt="">
            </div>
            <div id="btn" class="header-r" @click="addnav">
                <img src="../../../assets/images/手机端/首页手机端/更多.png" alt="">
            </div>
        </div>

        <div class="content">
            <div class="top-bar">
                <div class="top-bar__back" @click="goBack">
                    <i class="material-icons">&lt;</i>
                </div>
                <div class="top-bar__title">套餐选择</div>
            </div>
            <div class="main_top">
                <div class="main_top1">
                    <div class="main_top1_text">域</div>
                </div>
                <div class="main_top2">
                    <div class="main_top2_text1">域贝数据可视化分析平台</div>
                    <div class="main_top2_text2">订购日期：{{ getTime() }}</div>
                </div>
            </div>

            <!-- 导航栏 -->
            <div class="middle_bar">
                <el-tabs v-model="tabName" @tab-click="onTabClick">
                    <el-tab-pane class="middle_var_tab" label="选择套餐" name="package">
                        <div class="of3_second">
                            <div v-for="(item, index) of computedPriceList" class="package_item"
                                :class="{ 'select_item': currentPackageIndex == index }"
                                @click="onSelectPackage(item, index)" :key="index">
                                <div class="name">
                                    <span style="font-size: 18px;">{{ item.bb }}</span>
                                </div>
                                <div class="price">
                                    <span>￥</span>
                                    <span style="font-size: 18px;font-weight: 600;">{{ item.price }}</span>
                                    <span>/{{ item.time ? item.time : '年' }}</span>
                                </div>

                                <!-- 选中右下角 -->
                                <div class="select" v-if="currentPackageIndex == index">
                                    <img class="image" src="../../../assets/images/template_check.png" alt="" />
                                </div>
                            </div>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane class="middle_var_tab" label="选择模版" name="template">
                        <div class="of3_second">
                            <div v-for="(item, index) of templateList" class="package_item_template"
                                :class="{ 'select_item_template': currentPackageIndex == index }"
                                @click="onSelectPackage(item, index)" :key="item.bb">
                                <div style="font-size: 18px;" class="name">
                                {{ item.bb }}
                                </div>
                                <div class="patch">
                                {{ index == 1 ? '' : '赠送两个看板' }}
                                </div>
                                <div class="price">
                                <span>￥</span>
                                <span style="font-size: 18px;font-weight: 600;">{{ item.price }}</span>
                                </div>

                                <!-- 选中右下角 -->
                                <div class="select" v-if="currentPackageIndex == index">
                                <img class="image" src="../../../assets/images/template_check.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <div class="fixed-dialog">
                <div class="dialog-content">
                   <div class="dialog_title">套餐详情</div>
                </div>
                <div class="dialog_item">
                    <div>套餐名称</div>
                    <div>{{ currentPackage.bb }}</div>
                </div>
                <div class="dialog_item" style="padding:0 5% 0 8%;display: flex;justify-content: space-between;">
                    <div>购买时长</div>
                    <div>{{ currentPackage.bb == '体验版' ? '7天' : '1年' }}</div>
                </div>
                <div class="dialog_item2">
                    <div>到期时间</div>
                    <div>{{ getYearAfterTime(currentPackage) }}</div>
                </div>
                <div class="dialog_item2" style="padding:0 5% 0 8%;display: flex;justify-content: space-between;">
                    <div>订单总额</div>
                    <div>¥ {{ currentPackage.price * num }}</div>
                </div>
                <div class="dialog_item3">
                </div>
                <div class="dialog_item4">
                  <div>应付金额</div>
                  <div>¥ {{ currentPackage.price * num }}</div>
                </div>
                <div class="dialog_item5">
                  <div class="dialog_item5_left">微信支付</div>
                  <div class="dialog_item5_right">支付宝支付</div>
                </div>
            </div>
        </div>



        <div class="mask"></div>
        <div class="mask"></div>
        <div class="mask1"></div>
        <div class="erweima1">
        </div>
        <div class="ismask" @click.self="qiemask" v-show="ismask">
            <div class="isnav" v-show="isnav">
                <ul>
                <li @click="navto(1)">首页</li>
                <li @click="navto(9)">玉瓒云校园</li>
                <li @click="subMenu = !subMenu">一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
                <li v-if="subMenu" class="subLi" @click="navto(7)">产品详情</li>
                <li v-if="subMenu" class="subLi" @click="navto(8)">产品定价</li>
                <li @click="subMenu2 = !subMenu2">域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
                <li v-if="subMenu2" class="subLi" @click="navto(2)">域贝证书宝</li>
                <li v-if="subMenu2" class="subLi" @click="navto(3)">域贝大数据</li>
                <li v-if="subMenu2" class="subLi" @click="navto(4)">域贝一体化</li>
                <!-- <li @click="navto(2)">域贝证书宝</li>
                <li @click="navto(3)">域贝大数据</li>
                <li @click="navto(4)">域贝一体化</li> -->
                <li @click="navto(5)">解决方案</li>
                <li @click="navto(6)">关于掌网</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import moment from 'moment'
export default {

    components: {
        swiper,
        swiperSlide
    },
    computed: {
        computedPriceList() {
            if (this.activeIndex == 0) {
                return this.news == false ? this.priceList.filter(item => item.bb !== '体验版') : this.priceList
            } else {
                return this.templateList
            }
        },
    },
    data() {
        const _self = this
        return {
            priceList: [
                {
                    id: "000",
                    bb: "体验版",
                    color: '#3A95FE',
                    time: "7天",
                    bg: '#fff',
                    textColor: '#000',
                    price: 0.1,
                    rj: true,
                    yjs: "1个",
                    gj: false,
                    kb: "1个",
                    kbpassword: true,
                    kblj: false,
                    create: "",
                    file: true,
                    windowName: false,
                    windowLogo: false,
                    windowbgi: true,
                    data: null,
                    null1: "",
                    null2: "",
                    null3: "",
                    dzd: true,
                    sj: true,
                },
                {
                    id: "001",
                    bb: "基础版",
                    color: '#61C768',
                    textColor: '#fff',
                    bg: '#fff',
                    price: 98,
                    rj: true,
                    yjs: "5个",
                    gj: false,
                    kb: "10个",
                    kbpassword: true,
                    kblj: '3个',
                    create: "3个",
                    file: true,
                    windowName: true,
                    windowLogo: true,
                    windowbgi: true,
                    data: "自变化300组",
                    null1: "",
                    null2: "",
                    null3: "",
                    dzd: true,
                    sj: true,
                },
                {
                    id: "003",
                    bb: "高级版",
                    color: '#3C6998',
                    textColor: '#fff',
                    bg: '#fff',
                    price: 298,
                    rj: true,
                    yjs: "5个",
                    gj: true,
                    kb: "10个",
                    kbpassword: true,
                    kblj: true,
                    create: "6个",
                    file: "双倍空间",
                    windowName: true,
                    windowLogo: true,
                    windowbgi: true,
                    data: "数据库实时对接",
                    null1: "主流数据库配置接入",
                    null2: "支持http接口(get/post请求)\n 调用动态接入",
                    null3: "实时数据自动更新",
                    dzd: true,
                    sj: true,
                },
                {
                    id: "004",
                    bb: "旗舰版",
                    price: 998,
                    color: '#0075E6',
                    textColor: '#fff',
                    bg: '#fff',
                    rj: true,
                    yjs: "20个",
                    gj: true,
                    kb: "40个",
                    kbpassword: true,
                    kblj: true,
                    create: "10个",
                    file: "三倍空间",
                    windowName: true,
                    windowLogo: true,
                    windowbgi: true,
                    data: "数据库实时对接",
                    null1: "主流数据库配置接入",
                    null2: "支持http接口(get/post请求)\n 调用动态接入",
                    null3: "实时数据自动更新",
                    dzd: true,
                    sj: true,
                },
                {
                    id: "005",
                    bb: "专属版",
                    price: 1998,
                    color: '#FFFFFF',
                    textColor: '#fff',
                    bg: 'linear-gradient(110deg, #0091F1 0%, #005EDC 100%)',
                    rj: true,
                    yjs: "不限",
                    gj: true,
                    kb: "不限",
                    kbpassword: true,
                    kblj: true,
                    create: "不限",
                    file: "四倍独享空间",
                    windowName: true,
                    windowLogo: true,
                    windowbgi: true,
                    data: "数据库实时对接",
                    null1: "主流数据库配置接入",
                    null2: "支持http接口(get/post请求)\n 调用动态接入",
                    null3: "实时数据自动更新",
                    dzd: true,
                    sj: true,
                },
            ],
            templateList: [
                {
                    bb: "基础模版",
                    price: 50,
                },
                {
                    bb: "定制模版",
                    price: 100,
                }
            ],
            active: 0,
            isnav: false,
            ismask: false,
            name: '',
            phone: '',
            activeIndex: 0,
            swiperOption: {
                centeredSlides: true,
                slidesPerView: "auto",
                direction: 'horizontal',
                spaceBetween: 20,
                on: {
                    slideChangeTransitionEnd: function () {
                        _self.activeIndex = this.activeIndex + 1
                    }
                }
            },
            subMenu: false,
            subMenu2: false,
            tabName: 'package',
            currentPackageIndex: -1,
            currentPackage: {},
            num: 1,
            qrCodeShow: false,
        }
    },
    created() {
        this.currentPackageIndex = 0
        this.currentPackage = this.priceList[0]
    },
    watch: {
        currentPackageIndex: function (val) {
            if (this.activeIndex == 1 && this.currentPackageIndex == 1) {
                this.num = 8
                this.minValue = 8
            } else {
                this.num = 1
                this.minValue = 1
            }
        },
    },
    mounted() {
        // console.log(this.$refs.callUs_dialog.style.animation = 'callUs 1s infinite;'
    },
    methods: {
        getTime() {
            // 以年月日时分秒格式生成时间
            return moment().format("YYYY年MM月DD日 HH:mm:ss");
        },
        getYearAfterTime() {
            if (this.currentPackage.bb == '体验版') {
                // 加7天
                return moment().add(7, "days").format("YYYY/MM/DD");
            }
            // 以年月日时分秒格式生成一年后的时间
            return moment().add(1, "year").format("YYYY/MM/DD");
        },
        onSelectPackage(item, index) {
            clearInterval(this.timer)
            this.currentPackageIndex = index
            this.currentPackage = item
            this.qrCodeShow = false
        },
        onTabClick(tab) {
            this.activeIndex = tab.index
            this.currentPackageIndex = 0
            clearInterval(this.timer)
            this.qrCodeShow = false
            this.currentPackage = this.computedPriceList[this.currentPackageIndex]
        },
        
        goBack() {
            this.$router.go(-1);
        },
        onClickActive(index) {
            // 获取swiper实例

            this.activeIndex = index
            this.$refs.mySwiper.swiper.slideTo(index - 1)
        },
        addnav() {
            this.ismask = !this.ismask
            this.isnav = !this.isnav
        },
        qiemask() {
            console.log(111);
            this.ismask = false
            this.isnav = false
        },
        navto(n) {
            if (n == 1) {
                this.$router.push({ path: 'index' })
            } else if (n == 2) {
                this.$router.push({ path: 'hoproductservicepage' })
            } else if (n == 3) {
                this.$router.push({ path: 'hodate' })

            } else if (n == 4) {
                this.$router.push({ path: 'integratedpage' })
            } else if (n == 5) {
                this.$router.push({ path: 'cooperationpage' })
            } else if (n == 6) {
                this.$router.push({ path: 'aboutpage' })
            } else if (n == 7) {
                this.$router.push({ path: 'visualizationpage' })
            } else if (n == 8) {
                this.$router.push({ path: 'pricepage' })
            } else if (n == 9) {
                window.location.href='http://www.yuzanyun.com'
            }
        }
    }
}
</script>
<style lang="less" scoped>
a {
    text-decoration: none;
}

/* html {
  font-size: 50px;
} */

/* @media screen and (min-width: 1171px) {
  html {
    font-size: 78.666666667px;
  }
} */
@media screen and (min-width: 320px) {
    html {
        font-size: 21.33333333px;
    }
}

@media screen and (min-width: 360px) {
    html {
        font-size: 24px;
    }
}

@media screen and (min-width: 375px) {
    html {
        font-size: 25px;
    }
}

@media screen and (min-width: 384px) {
    html {
        font-size: 25.6px;
    }
}

@media screen and (min-width: 390px) {
    html {
        font-size: 26px;
    }
}

@media screen and (min-width: 400px) {
    html {
        font-size: 26.66666667px;
    }
}

@media screen and (min-width: 414px) {
    html {
        font-size: 27.6px;
    }
}

@media screen and (min-width: 424px) {
    html {
        font-size: 28.26666667px;
    }
}

@media screen and (min-width: 480px) {
    html {
        font-size: 32px;
    }
}

@media screen and (min-width: 540px) {
    html {
        font-size: 36px;
    }
}

@media screen and (min-width: 720px) {
    html {
        font-size: 48px;
    }
}

@media screen and (min-width: 750px) {
    html {
        font-size: 50px;
    }
}

li {
    list-style: none;
}

p {
    margin: 0;
}

ul {
    margin: 0;
    padding: 0;
}

body {
    min-width: 320px;
    max-width: 750px;
    width: 15rem;
    margin: 0 auto;
    line-height: 1.5;
    font-family: PingFangSC-Regular, sans-serif;
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    height: 2.4rem;
    padding-bottom: .4688rem;
    width: 100%;
    padding-top: .7031rem;
    background-color: #fff;
    z-index: 9999999999;
}

.header-l {
    float: left;
    margin-left: .75rem;
    /* background-image: url('../images/首页 手机端/logo.png'); */
}

.header-l img {
    height: .8rem;
    object-fit: cover;
}

.header-r {
    width: 1.75rem;
    height: 1.375rem;
    float: right;
}

.header-r img {
    width: .62rem;
    height: .5rem;
}


@keyframes slideshow {
    0% {
        left: 0;
    }

    100% {
        left: -200%;
    }
}

@-webkit-keyframes Index-module_scrollToRight_HaAA0 {
    0% {
        -webkit-transform: translate3d(-50%, 0, 0);
    }

    to {
        -webkit-transform: translateZ(0);
    }
}

@keyframes Index-module_scrollToRight_HaAA0 {
    0% {
        -webkit-transform: translate3d(-50%, 0, 0);
    }

    to {
        -webkit-transform: translateZ(0);
    }
}


.mask {
    display: none;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    opacity: .2;
}


.erweima {
    width: 1.74rem;
    height: 1.74rem;
    position: absolute;
    right: .56rem;
    bottom: 2rem;
}

.erweima1 {
    display: none;
    position: fixed;
    bottom: 50%;
    left: 50%;
    transform: translate(-3.6rem, 3.6rem);
}

.erweima1 img {
    width: 7.2rem;
    height: 7.2rem;
}

.ismask {
    position: fixed;
    z-index: 100000 !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 10000px !important;
    background: rgba(0, 0, 0, .2) !important;
}

.isnav {
    position: fixed;
    top: 2.4rem;
    right: 0;
    width: 9rem;
    height: 100%;
    background-color: #fff;
    z-index: 9999;

    ul {
        padding: 0 .48rem;

        li {
            height: 2.12rem;
            line-height: 2.12rem;
            color: #2c3e5c;
            font-size: .56rem;
            font-family: Arial, PingFangSC-Semibold, sans-serif;
            border-bottom: 1px solid #eee;
        }

        .subLi {
            padding-left: .58rem;
        }

        li:nth-child(1) {
            border-top: 1px solid #eee;
        }
    }
}

.content {
    width: 100%;
    height: 800px;
    margin-top: 2.4rem;
    border-top: 1px solid transparent;
    background-image: url("../../../assets/images/手机端/支付背景.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.top-bar {
    position: fixed;
    margin-top: 2.4rem;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: transparent;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.top-bar__back {
    position: absolute;
    color: #191919;
    left: 10px;
    font-size: 24px;
    cursor: pointer;
}

.top-bar__title {
    font-size: 18px;
    font-weight: 500;
    color: #191919;
}

.main_top {
    height: 55px;
    width: 100%;
    margin-top: 70px;
    position: relative;

    .main_top1 {
        height: 55px;
        width: 55px;
        background-color: rgba(25, 137, 255, 1);
        border-radius: 8px;
        margin-left: 10px;
    }

    .main_top1_text {
        height: 55px;
        width: 55px;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: normal;
        text-align: center;
        padding-top: 16px;
    }

    .main_top2 {
        height: 55px;
        width: 200px;
        position: absolute;
        top: 0;
        left: 80px;

        .main_top2_text1,
        .main_top2_text2 {
            font-family: PingFangSC-Regular;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
        }

        .main_top2_text1 {
            font-size: 16px;
            color: rgba(25, 25, 25, 1);
            margin-top: 8px;
        }

        .main_top2_text2 {
            font-size: 13px;
            color: rgba(138, 148, 169, 1);
            margin-top: 5px;
        }
    }
}

.middle_bar {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    text-align: center;
    margin-top: 20px;
    width: 100%;
    .middle_var_tab{
        text-align: center;
    }
}
// .el-tabs {
//     display: inline-block;
// }

.of3_second {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;

    .select_item {
        background: linear-gradient(315deg, #fffffe 0%, #fdf8ed 100%);
        border: 1px solid #cc943a !important;
        border-radius: 6px;
    }
    .select_item_template{
        background: linear-gradient(315deg, #FDFEFF 0%, #EFF7FF 100%);
        border: 1px solid #1989FF !important;
        border-radius: 6px;
    }

    .package_item {
        // margin-top: 10px;
        margin: 10px 4px 0 4px;
        border-radius: 6px;
        border: 1px solid #cdcdcd;
        width: 168px;
        height: 100px;
        color: #985512;
        position: relative;

        .name {
            width: 100%;
            text-align: center;
            margin-top: 16px;
        }

        .price {
            margin-top: 15px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #985512;
        }

        .select {
            background: url("../../../assets/images/package_select.png");
            background-size: 100% 100%;
            width: 30px;
            height: 30px;
            position: absolute;
            right: 0;
            bottom: 0;

            .image {
                position: absolute;
                right: 0px;
                bottom: 0px;
                width: 60%;
                height: 60%;
            }
        }
    }
    .package_item_template {
        // margin-top: 10px;
        margin: 10px 4px 0 4px;
        border-radius: 6px;
        border: 1px solid #cdcdcd;
        width: 168px;
        height: 100px;
        color: #985512;
        position: relative;

        .name {
            width: 100%;
            text-align: center;
            margin-top: 16px;
        }

        .price {
            margin-top: 15px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #985512;
        }
        .patch {
            width: 100%;
            height: 10px;
            text-align: center;
            margin-top: 5px;
            font-size: 12px;
            color: #999;
        }

        .select {
            background: url("../../../assets/images/template_select.png");
            background-size: 100% 100%;
            width: 30px;
            height: 30px;
            position: absolute;
            right: 0;
            bottom: 0;

            .image {
                position: absolute;
                right: 0px;
                bottom: 0px;
                width: 60%;
                height: 60%;
            }
        }
    }
}

.fixed-dialog {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 212px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 5% 5% 0 0;
  box-shadow: 0px 0px 16px 0px rgba(151, 188, 225, 0.43);
  z-index: 999;
    .dialog-content {
        padding: 5%;
        width: 100%;
        max-width: 400px;
        box-sizing: border-box;
    }
    .dialog_title{
        width: 100%;
        height: 18px;
        font-size: 16px;
        font-weight: 600;
        color: #191919;
    }
    .dialog_item{
        // margin-top: 10%;
        display: flex;
        width: 50%;
        padding-left: 5%;
        float: left;
        :nth-child(1) {
            font-size: 14px;
            line-height: 15px;
            color: #8a94a9;
            }
        :nth-child(2) {
            margin-left: 5%;
            font-size: 14px;
            line-height: 15px;
            color: #191919;
        }
    }
    .dialog_item2{
        margin-top: 4%;
        display: flex;
        width: 50%;
        padding-left: 5%;
        float: left;
        :nth-child(1) {
            font-size: 14px;
            line-height: 15px;
            color: #8a94a9;
            }
        :nth-child(2) {
            margin-left: 5%;
            font-size: 14px;
            line-height: 15px;
            color: #191919;
        }
    }
    .dialog_item3 {
        width: 90%;
        border: 1px dashed #cdcdcd;
        margin: 0 auto;
        margin-top: 15%;
    }
    .dialog_item4 {
        margin-top: 2%;
        margin-left: 50%;
        padding:0 5% 0 8%;
        display: flex;
        width: 50%;
        display: flex;
        justify-content: space-between;
        :nth-child(1) {
            font-size: 14px;
            color: #191919;
            height: 90%;
            line-height: 28px;
        }
        :nth-child(2) {
            font-size: 16px;
            font-weight: 600;
            color: #ec2b4a;
            height: 90%;
            line-height: 28px;
        }
    }
    .dialog_item5{
        height: 36px;
        margin-top: 2%;
        padding:0 5% 0 5%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        :nth-child(1) {
            width: 45%;
            font-size: 14px;
            color: #1989FF;
            height: 90%;
            line-height: 34px;
            text-align: center;
            border:1px solid #1989FF;
            border-radius: 10px;
        }
        :nth-child(2) {
            background-color: #1989FF;
            width: 45%;
            font-size: 14px;
            color: #fff;
            height: 90%;
            line-height: 34px;
            text-align: center;
            border-radius: 10px;
        }
    }
}


</style>
